// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { selectChannels } from '@/modules/Channels';
import { Header } from '@/modules/Layout';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { cleanSync, getCleanupDatabaseData } from '../../feature/actionCreators';

// Components
import { showSuccessToast, useForm } from '@/components';
import { Spinner } from '@/ui';
import { CleanupDatabaseTable, CleanSyncForm } from '../../components';
import { StyledContentWrapper } from './CleanUpDatabaseContainerStyles';

// Helpers
import { TCleanSyncFormValues } from '../../helpers';
import { useGetCleanupDatabaseData, useGetEntities } from '../../hooks';

const CleanUpDatabaseContainer = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const channels = useAppState(selectChannels);

  const { isLoading } = useGetEntities();
  const { isLoadingCleanupData, cleanupDatabaseData } = useGetCleanupDatabaseData();

  const [cleanSyncForm] = useForm();

  const handleCleanSyncSubmit = async (values: TCleanSyncFormValues) => {
    try {
      await dispatch(cleanSync(values)).unwrap();
      cleanSyncForm.resetFields();
      showSuccessToast({
        message: t('message_sync_success'),
      });
      await dispatch(getCleanupDatabaseData()).unwrap();
    } catch {}
  };

  return (
    <>
      <Header title={t('menu_akeneo_clean_up')} />
      <Spinner spinning={isLoading}>
        <CleanSyncForm onSubmit={handleCleanSyncSubmit} cleanSyncForm={cleanSyncForm} channels={channels ?? []} />
      </Spinner>
      <StyledContentWrapper>
        <CleanupDatabaseTable isLoading={isLoadingCleanupData} data={cleanupDatabaseData} />
      </StyledContentWrapper>
    </>
  );
};

export default CleanUpDatabaseContainer;
